import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import StaticPostLayout from '../components/StaticPostLayout';
import InfoSection from '../components/TripInfo/how-to-find-eco-friendly-hiking-gear';

class HowToFindEcoFriendlyHikingGear extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>How to Find Eco-Friendly Hiking Gear | Beginner Guide</title>
          <meta name="description" content="Find eco-friendly hiking gear with this complete beginner guide. Discover sustainable materials, ethical brands, and smart tips to reduce your environmental impact." />
          <meta property="og:title" content="How to Find Eco-Friendly Hiking Gear | Beginner Guide" />
          <meta property="og:description" content="Find eco-friendly hiking gear with this complete beginner guide. Discover sustainable materials, ethical brands, and smart tips to reduce your environmental impact." />
          <meta property="og:url" content="https://exploroff.com/hiking-guides/how-to-find-eco-friendly-hiking-gear" />
          <meta property="og:type" content="article" />
          <meta property="og:image" content="https://exploroff.com/img/how-to-find-eco-friendly-hiking-gear/eco-friendly-hiking-gear.webp" />
          <link rel="canonical" href="https://exploroff.com/hiking-guides/how-to-find-eco-friendly-hiking-gear" />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org", "@type": "BlogPosting",
            headline: "How to Find Eco-Friendly Hiking Gear",
            description: "Find eco-friendly hiking gear with this complete beginner guide. Discover sustainable materials, ethical brands, and smart tips to reduce your environmental impact.",
            image: ["https://exploroff.com/img/how-to-find-eco-friendly-hiking-gear/eco-friendly-hiking-gear.webp"],
            author: { "@type": "Organization", name: "ExplorOFF" },
            publisher: { "@type": "Organization", name: "ExplorOFF", logo: { "@type": "ImageObject", url: "https://exploroff.com/img/favicon.png" } },
            mainEntityOfPage: { "@type": "WebPage", "@id": "https://exploroff.com/hiking-guides/how-to-find-eco-friendly-hiking-gear" }
          })}</script>
        </Helmet>
        <MessengerCustomerChat pageId="101590111335192" appId="695593052231950" />
        <StaticPostLayout
          title="How to Find Eco-Friendly Hiking Gear"
          category="hiking-guides"
          slug="how-to-find-eco-friendly-hiking-gear"
          excerpt="Discover sustainable materials, ethical brands, and smart tips to reduce your environmental impact on the trail."
          tags={['gear', 'sustainability']}
          readTime={6}
        >
          <InfoSection />
        </StaticPostLayout>
      </>
    );
  }
}

export default HowToFindEcoFriendlyHikingGear;
